import React, { useState } from 'react'
import * as routeLink from "../../constants/routeLink";

import TopInfo from "./../../components/TopInfo/index";
import BalanceInfo from "./../../components/BalanceInfo/index";
import TopLevel from "./../../components/TopLevel/index";
import Modal from "../../components/Modal/index";

import { useNavigate } from 'react-router-dom';
const Index = (props) => {

  const navigate = useNavigate();
  const onclickChangePage = (path) => {
    navigate(path);
  }

  const [modal1, setModal1] = useState(null);
  const [modal2, setModal2] = useState(null);
  return (
    <div className='d-flex justify-content-center align-items-center flex-column'>

      <TopInfo />
      <TopLevel />
      <BalanceInfo />
      <div className='w-100 d-flex justify-content-center align-items-start flex-column p-2'>
        <h4 className='text-white d-flex m-0 mb-1'>Daily rewards</h4>

        <div className='card-custom card-custom-task w-100 p-2 px-3 radius-custom justify-content-center align-items-center mt-2' style={{ minHeight: "30px" }}>

          <div className='card-img' style={{ width: "30px", height: "30px" }}>

            <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/star1.png`} />
          </div>
          <div className='d-flex justify-content-center align-items-start flex-column'>
            <span className='text-white fw-bold mb-0'>full energy</span>
            <div className='d-flex w-100'>
              <span className='text-white'>Comming soon</span>
            </div>
          </div>


        </div>
        <div className='card-custom card-custom-task w-100 p-2 px-3 radius-custom justify-content-center align-items-center mt-2 ' style={{ minHeight: "30px" }}>

          <div className='card-img' style={{ width: "30px", height: "30px" }}>

            <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/star1.png`} />
          </div>
          <div className='d-flex justify-content-center align-items-start flex-column'>
            <span className='text-white fw-bold mb-0'>full energy</span>
            <div className='d-flex w-100'>
              <span className='text-white'>Comming soon</span>
            </div>
          </div>


        </div>
      </div>
      <div className='w-100 d-flex justify-content-center align-items-start flex-column p-2'>
        <h4 className='text-white d-flex m-0 mb-1'>Daily rewards</h4>
        <div className='w-100 list-grid-2'>
          <button className='card-custom border-unset scale_btn card-custom-task w-100 p-2 px-3 radius-custom justify-content-center align-items-center mt-2' style={{ minHeight: "30px" }}  onClick={() => setModal1(true)} >

            <div className='card-img' style={{ width: "30px", height: "30px" }}>

              <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/star1.png`} />
            </div>
            <div className='d-flex justify-content-center align-items-start flex-column'>
              <span className='text-white fw-bold mb-0 font-size-global'>Multitap</span>
              <div className='d-flex w-100'>
              <div className='d-flex justify-content-center align-items-center'>

                 
                    <button className='btn d-flex justify-content-center align-items-center  btn-custom-sm  scale_btn btn-balance p-0' style={{ width:"20px",height:"20px" }}> <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} /></button>
                          <span className='text-white   mx-1 font-size-global-sm color-sub-pri'>1.024</span>
                          <span className='text-white   font-size-global-sm '>1lv1</span>
                    </div>
              </div>
            </div>


          </button>
          <button className='card-custom  border-unset scale_btn card-custom-task w-100 p-2 px-3 radius-custom justify-content-center align-items-center mt-2' style={{ minHeight: "30px" }} onClick={() => setModal2(true)}>

            <div className='card-img' style={{ width: "30px", height: "30px" }}>

              <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/star1.png`} />
            </div>
            <div className='d-flex justify-content-center align-items-start flex-column'>
              <span className='text-white fw-bold mb-0 font-size-global'>Energy limit</span>
              <div className='d-flex w-100'>
              <div className='d-flex justify-content-center align-items-center'>

                 
                    <button className='btn d-flex justify-content-center align-items-center  btn-custom-sm  scale_btn btn-balance p-0' style={{ width:"20px",height:"20px" }}> <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} /></button>
                          <span className='text-white   mx-1 font-size-global-sm color-sub-pri'>1.024</span>
                          <span className='text-white   font-size-global-sm '>1lv1</span>
                    </div>
              </div>
            </div>


          </button>
        </div>

      </div>


      <Modal setHide={setModal1} show={modal1}>
        <div className='w-75 d-flex justify-content-center align-items-center flex-column p-2 m-0 m-auto'>
          <div className='card-icon me-2' style={{ width: "80px", height: "80px" }}>
            <img className='w-100 h-100 object-fit-contain' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
          </div>

          <h4 className='text-white text-center fs-extra d-flex m-0 mb-3'>Multitap LVL1</h4>
          <span className='text-white text-center'>Increase amount of PAWS you can earn per tab by+1</span>
         
          <div className='d-flex justify-content-center align-items-start flex-column mb-3'>
            <div className='d-flex w-100 justify-content-center align-items-center'>
              <div className='card-icon me-2 bg-white radius-custom-8' style={{ width:"30px",height:"30px" }} >
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
              <span className='fw- fs-extra text-white'>{"50,000"}</span>
            </div>
          </div>
          
        
        </div>
           <button className='d-flex w-50 m-0 m-auto justify-content-center align-items-center  scale_btn btn btn-custom-2' style={{ height:"40px",minHeight:"unset" }}>
                <span className='text-white fw-bold'>Buy</span>
          </button>
      </Modal>


      <Modal setHide={setModal2} show={modal2}>
        <div className='w-75 d-flex justify-content-center align-items-center flex-column p-2 m-0 m-auto'>
          <div className='card-icon me-2' style={{ width: "80px", height: "80px" }}>
            <img className='w-100 h-100 object-fit-contain' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
          </div>

          <h4 className='text-white text-center fs-extra d-flex m-0 mb-3'>Energy Limit LVL2</h4>
          <span className='text-white text-center'>Increase your energy capacity by +500 energy points</span>
        
          <div className='d-flex justify-content-center align-items-start flex-column mb-3'>
            <div className='d-flex w-100 justify-content-center align-items-center'>
              <div className='card-icon me-2 bg-white radius-custom-8' style={{ width:"30px",height:"30px" }} >
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
              <span className='fw- fs-extra text-white'>{"50,000"}</span>
            </div>
          </div>
          
        
        </div>
        <button className='d-flex w-50 m-0 m-auto justify-content-center align-items-center  scale_btn btn btn-custom-2' style={{ height:"40px",minHeight:"unset" }}>
                <span className='text-white fw-bold'>Buy</span>
          </button>
      </Modal>
    </div>
  )
}

export default Index;
